// extracted by mini-css-extract-plugin
export var deleteIcon = "_ny-5";
export var deleteOption = "_ny-3";
export var divider = "_ny-2";
export var downloadIcon = "_ny-4";
export var drawer = "_ny-0";
export var drawerFooter = "_ny-6";
export var drawerOpen = "_ny-1";
export var highlighted = "_ny-7";
export var lighterHighlight = "_ny-8";